// extracted by mini-css-extract-plugin
module.exports = {"input":"file-upload-button_input__syDy5"};